module.exports = __webpack_public_path__ + "static/media/preview.ec4a2979.png";